import { pages as rupages } from "src/i18n/dictionaries/ru/pages";

export const pages: Record<keyof typeof rupages, string> = {
  // Histories — итог ставки в мобильной таблице
  "components.routes.pages.Histories.table.result.return": "Refunded",
  "components.routes.pages.Histories.table.result.win": "Win",
  "components.routes.pages.Histories.table.result.loss": "Loss",

  // Positions — заголовок колонки количества
  "components.routes.pages.Positions.table.quantity": "Qty",

  // EventDetail — фолбэки названий исходов на мобильных кнопках
  "components.routes.pages.EventDetail.outcome.yes": "Yes",
  "components.routes.pages.EventDetail.outcome.no": "No",
};
